import { useMemo } from "react";
import type { Meeting } from "@platform/types/platform.types";
import { useUserMeetings } from "./useUserMeetings";
import { getClosestMeetingToCurrentTime } from "@platform/utils/getClosestMeetingToCurrentTime";

/**
 * Hook to get the current/closest meeting for the user.
 *
 * Uses useUserMeetings to fetch meetings and finds the one closest to the current time.
 */
export function useCurrentMeeting(): {
  currentMeeting: Meeting | null;
  isLoading: boolean;
} {
  const { meetings, isLoading } = useUserMeetings();

  // Find the closest meeting to the current time
  const currentMeeting = useMemo(() => {
    if (!meetings || meetings.length === 0) return null;

    return getClosestMeetingToCurrentTime({ meetings });
  }, [meetings]);

  return {
    currentMeeting,
    isLoading,
  };
}

export default useCurrentMeeting;
